export default [{
  'conversation_id': 'fd6c3d65-2d5e-4d47-ae50-21d91359ebc5',
  'sender_name': 'Helô',
  'isButtonChoice': true,
  'request_datetime': '2022-08-10T21:21:55.214Z',
  'event_text': 'Sim'
},
{
  'conversation_id': '254d4373-57b0-41a7-9722-666cb12dfc2b',
  'sender_name': 'Cloves',
  'isButtonChoice': true,
  'request_datetime': '2022-08-10T19:08:14.302Z',
  'event_text': 'Não'
},
{
  'conversation_id': '254d4373-57b0-41a7-9722-666cb12dfc2b',
  'sender_name': 'Laura Carlota Custódio Marinho',
  'isButtonChoice': true,
  'request_datetime': '2022-08-10T19:07:59.939Z',
  'event_text': 'Finalizar Conversa'
},
{
  'conversation_id': '254d4373-57b0-41a7-9722-666cb12dfc2b',
  'sender_name': 'Wellington Marinho Soares',
  'isButtonChoice': true,
  'request_datetime': '2022-08-10T19:07:44.421Z',
  'event_text': 'quero pedir uma pizza'
},
{
  'conversation_id': '78fae515-b369-4b4e-8e23-03b3e6186928',
  'sender_name': 'Maria Clara Dores das Neves',
  'isButtonChoice': false,
  'request_datetime': '2022-08-10T19:06:36.038Z',
  'event_text': 'Pagamento'
},
{
  'conversation_id': '78fae515-b369-4b4e-8e23-03b3e6186928',
  'sender_name': 'Berenice Maria Gonçalves Bento',
  'isButtonChoice': false,
  'request_datetime': '2022-08-10T19:06:29.284Z',
  'event_text': 'Vazamento de água'
},
{
  'conversation_id': '78fae515-b369-4b4e-8e23-03b3e6186928',
  'sender_name': 'Eu mesma, Maria do Bairro',
  'isButtonChoice': false,
  'request_datetime': '2022-08-10T19:06:22.180Z',
  'event_text': 'quero pedir uma pizza'
},
{
  'conversation_id': 'ec09e2da-6c11-4954-8b41-695c6ba7e3cf',
  'sender_name': 'Raul Custódio Marinho',
  'isButtonChoice': false,
  'request_datetime': '2022-08-10T19:05:48.028Z',
  'event_text': 'Convênio'
},
{
  'conversation_id': 'ec09e2da-6c11-4954-8b41-695c6ba7e3cf',
  'sender_name': 'eu mesmo, Jaiminho Carteiro',
  'isButtonChoice': false,
  'request_datetime': '2022-08-10T19:05:29.002Z',
  'event_text': 'quero pedir um suco de tamarindo'
},
{
  'conversation_id': '78fae515-b369-4b6e-8e23-03b3e6186928',
  'sender_name': 'Helena Albuquerque de Souza Ferraz',
  'isButtonChoice': false,
  'request_datetime': '2022-08-08T20:35:37.577Z',
  'event_text': 'quero pedir uma esfirra vegetariana'
}]
